import React, { FC } from 'react'

import styled from 'styled-components'

import { Box } from '@style-port/roov-ui-components-react'
import { Txt } from 'src/components/atoms'
import { BackToSignInLinkTxt } from 'src/components/molecules'

const Container = styled(Box)`
  background: rgba(255, 255, 255, 0.6);
  border-radius: 1.14rem;
`

type Props = {
  forgetPasswordEmail: string
  className?: string
}

export const PasswordSentEmail: FC<Props> = ({ forgetPasswordEmail, className }) => {
  return (
    <section className={className}>
      <Container padding="--r3">
        <div className="tw-flex tw-flex-col tw-items-center">
          <Txt className="tw-font-bold">パスワード確認メール送信</Txt>
          <div className="tw-mt-s1 tw-text-center">
            <Txt sizeType="s" tag="span" className="tw-font-bold">
              {forgetPasswordEmail}
            </Txt>
            <Txt sizeType="s" tag="span">
              へ<br />
              パスワード確認メールを送信しました。
              <br />
              メールに記載されたURLをクリックし、パスワードの再設定を行ってください。
            </Txt>
          </div>

          <BackToSignInLinkTxt className="tw-mt-s1" />
        </div>
      </Container>
    </section>
  )
}
